import { createTheme } from '@mui/material/styles';

// Create a theme instance.
const theme = createTheme({
  typography: {
    fontFamily: ['Inter', 'sans-serif', 'Roboto', '"Helvetica Neue"', 'Arial'].join(','),
  },
  components: {
    MuiCheckbox: {
      defaultProps: {
        color: 'primary',
      },
    },
  },
});

export default theme;
